module.exports = "<div class=\"logo\" (click)=\"goToPage('landingPage')\">\n  <img src=\"assets/logo/logo.svg\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/common-components/logo-2/logo-2.component.html
// module id = ./src/app/home/common-components/logo-2/logo-2.component.html
// module chunks = main